import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import DemoForm from '@segment/templates/Forms/DemoForm'

const copy = {
  heading: `Ready to transform your customer experience with personalization?`,
  description: `Join the 25,000+ companies on the Segment platform today.`,
}

const form = {
  customFormIdentifier: `cnt-personalizationreport23-demo`,
}

const WantToGetTheMost: FC = () => {
  return (
    <StyledSectionBase id="get-most-out-of-customer-data" variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <StyledCopyHeading variant="h2" tag="h2">
            {copy.heading}
          </StyledCopyHeading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <SectionContents>
        <DemoForm customFormIdentifier={form.customFormIdentifier} customTrackingType={form.customFormIdentifier} />
      </SectionContents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 40px;
  }
`

const StyledCopyHeading = styled(CopyText.Heading)`
  max-width: 684px;
`

const SectionContents = styled(Section.Contents)`
  justify-content: center;
  display: flex;
  max-width: 417px;
`

export default WantToGetTheMost
